import { useEffect, useState } from "react";
import Landing from "./Landing";
import { useLocation, useNavigate } from "react-router-dom";
// import { getBlogs } from "../app/features/blogs/blogsSlice";
// import { useDispatch, useSelector } from "react-redux";
import { CATEGORIES, popular, posts } from "../utils/dummyData";
import { Link } from "react-router-dom";
import { Card, Pagination, PopularPosts, PopularWriters } from "../components";
import { MdAdd } from "react-icons/md";

const Blogs = () => {
  // const { given_name, family_name, email, isAdmin } = useSelector(state => state.auth)
  // const { blogs } = useSelector(state => state.blogs)
  // const navigate = useNavigate()
  // const dispatch = useDispatch()
  // const location = useLocation();
  // const { pathname } = location;
  const numOfPages = 4;
  const [page, setPage] = useState(0);

  // useEffect(() => {
  //   dispatch(getBlogs())
  // }, [pathname]);


  const handlePageChange = (val) => {
    setPage(val);
    console.log(val);
  };

  if (posts?.length < 1)
    return (
      <div className="w-full h-full py-8 flex items-center justify-center">
        <span className="text-lg text-slate-500">No Post Available</span>
      </div>
    );
  return (
    <div className="py-10 2xl:py-5">
      {/* {email && isAdmin && (
        <div className="flex flex-col sm:flex-row items-center justify-between md:w-[1000px] my-8 pr-8">
          <h3 className="text-center font-bold text-3xl pb-4">Blogs</h3>
          <div className="flex items-center px-2 w-full justify-around">
            <p className="text-center text-lighter text-md">
              {given_name} {family_name}, Bring Your Ideas to Life - Write Your
              Next Post Today!
            </p>
            <div
              onClick={() => navigate("/create-blog")}
              className="bg-bg_light p-2 rounded-xl h-min w-min cursor-pointer"
            >
              <MdAdd size={20} />
            </div>
          </div>
        </div>
      )} */}
      <div className="px-0 lg:pl-20 2xl:px-20 ">
        <div className="w-full flex flex-wrap py-10 gap-8">
          {CATEGORIES.map((cat) => (
            <Link
              to={`/category?cat=${cat?.label}`}
              className={`flex items-center justify-center gap-3 ${cat.color} text-white font-semibold text-base px-4 py-2 rounded cursor-pointer`}
              key={cat.label}
            >
              {cat?.icon}
              <span>{cat.label}</span>
            </Link>
          ))}
        </div>
        <Landing />
        <div className="w-full flex flex-col md:flex-row gap-10 2xl:gap-20">
          <div className="w-full md:w-1/4 flex flex-col gap-y-12">
            <PopularPosts posts={popular?.posts} />

            <PopularWriters data={popular?.writers} />
          </div>
          <div className="w-full md:w-2/3 flex flex-col gap-y-28 md:gap-y-14">
            {posts?.map((post, index) => (
              <Card key={post?._id} post={post} index={index} />
            ))}

            <div className="w-full flex items-cemter justify-center">
              <Pagination
                totalPages={numOfPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
